import React from 'react';
import PropTypes from 'prop-types'

const FaqItem = (props) => {   
    const createMarkup = () => {
        return {__html: props.text};
    }

    return (
        <div className="tab">
            <input type="checkbox" id={props.id} name="tab-group"/>
            <label htmlFor={props.id} className="tab-title">{props.name}</label> 
            <div className="tab-content"> 
                <div dangerouslySetInnerHTML={createMarkup()} />
            </div> 
        </div>
    )
}

export default FaqItem;

FaqItem.propTypes = {
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
  }